import { Chart } from "react-google-charts";
import {
  getPayloadByDateRange,
  preparePayload,
} from "./Services/TruckDataService";

export default function TruckChart(props) {
  return (
    <Chart
      width={"1400px"}
      height={"500px"}
      chartType="Timeline"
      loader={<div>Loading Chart</div>}
      data={getPayloadByDateRange(
        props.dateRange[0],
        props.dateRange[1],
        preparePayload(props.truckList)
      )|| null}
      //data={preparePayload(props.truckList)}
      options={{
        timeline: {
          groupByRowLabel: true,
        },
      }}
      rootProps={{ "data-testid": "4" }}
    />
  );
}
